import React, { useState } from "react";
import { Button, Form, Input, Label, Card} from "reactstrap";
import logoCiba from "../../assets/images/logo.png";
import { enviarMailRecupero, getContrato, isNew, getUsuario } from "../../services/api"
import { useHistory } from "react-router";
// import respuestasFalsas from "../registro/RespuestasFalsas";
import { getRespuestasFalsasDomicilio, getRespuestasFalsasNombre, getRespuestasFalsasPlanes } from '../../services/preguntas';

const initialState = { 
  dni: "", 
  msg: "", 
  socio: null, 
}

const Recupero = () => {
  const [state, setState] = useState(initialState)
  const [paso, setPaso] = useState(1)
  const [loading, setLoading] = useState(false)
  // para los usuarios que ya estan registrados pero sin email.
  const [direcciones, setDirecciones] = useState(getRespuestasFalsasDomicilio());
  const [nombres, setNombres] = useState(getRespuestasFalsasNombre());
  const [planes, setPlanes] = useState(getRespuestasFalsasPlanes());

  const history = useHistory()

  const handleInputChange = async (event) => {
    const target = event.nativeEvent.target;
    const name = target.name;
    const value = target.value;
    await setState({...state,
      [name]: value,
    });

  }

  const handleQuestions = (event) => {
    event.preventDefault();
    const { chosenDirection, chosenNames, chosenPlan } = state;
    const { direccion, apellido_nombres, plan } = socio;
    if(
      chosenDirection.trim() === direccion.trim() && 
      chosenNames.trim() === apellido_nombres.trim() && 
      chosenPlan.trim() === plan.trim()
      ){
        setPaso(5)
    }else{
      setPaso(6)
    }
  }

  const handleSearch = async (event) => {
    event.preventDefault();
    const nuevoUser = await isNew(state.dni);
    if(nuevoUser){
      setPaso(0);
    }else {
      let user = await getUsuario(state.dni);
      if(user){
        await setState({ ...state, socio: user })
        if(user?.email?.length > 1){
          sendMail(user)
          console.log('tiene email')
        }else{
          const socio = await getContrato(state.dni);
          if(socio){
            setDirecciones([...direcciones, socio.direccion].sort());
            setNombres([...nombres, socio.apellido_nombres].sort());
            setPlanes([...planes, socio.plan].sort());
            setState({...state, socio})
            setPaso(4)
            console.log('no tiene email')
          }else{
            //setPaso(3)
          }
          
        }
      }
    }
  }

  const handleEmail = async (event) => {
    event.preventDefault();
    setLoading(true)
    let user = await getUsuario(state.dni);
    sendMail({...user, email: email})
  }

  const sendMail = async (socio) => {
    var url_redirect_app = handlequery().get("app");

    let html = `<img src='https://ciba.com.ar/images/login/Ciba-App-Recupero-Contrasena.png' alt=''/>
                <br/>
                <span style="color:#A9A9A9">Para ingresar una nueva contraseña haz click <a href="https://ciba.com.ar/apptest/#/recupero/token/?a=DY0xqwlhePc4iKfJuXlMnmd5d7v44039th!jONb4o4ZojAQcfwFS3e2lJOkbVDrwE!&c=${socio.codigo_sms}&d=${socio.numero_documento}${url_redirect_app ? '&app='+url_redirect_app : '' }" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable" data-linkindex="0">aquí</a></span>`
    const resp = await enviarMailRecupero({ html, email: socio.email })
    // console.log(resp)
    if(resp){
      setPaso(3)
    }else{
      setPaso(6)
    }
  }

  // ver de sacar para no repetir esto 
  const handlequery = () => {
    return new URLSearchParams(window.location.hash.split("?")[1]);
  };

  const handleRedirect = () => {
    var url = handlequery().get("app");
    if(url){
      window.location.href = url;
    }else{
      history.push('/')
    }
    
  }

  const handleModificarEmail = () => {
    var url_redirect_app = handlequery().get("app");
    history.push('/modificar-email?dni='+state.dni+'&app='+url_redirect_app)
  }

  const { msg, socio, email} = state;


  const handlePasos = () => {
    //TODO: pasarlo a un switch y en componentes diferentes
      return  paso === 0 ? 
                <>
                  <p className='my-5 pt-2'>Usted no se encuentra registrado...</p>
                  <Button className="btn btn-continuar" onClick={() => history.push('/registro')}>
                    Registrarme
                  </Button>
                </>
              : paso === 1 ? 
                <Form onSubmit={handleSearch}> 
                  <p>
                    <Input
                      name="dni"
                      placeholder="DNI"
                      type="text"
                      className="inputDni"
                      onChange={handleInputChange}
                    />
                  </p>
                  <p>{msg}</p>
                  <Button className="btn btn-continuar" type="submit" disabled={loading}>
                    Continuar
                  </Button>
                </Form>
              : paso === 3 ? 
                <>
                  <p className='my-5 pt-2'>Hemos enviado un link a su correo electrónico ({socio?.email.substring(0,6)}****) para recuperar la contraseña</p>
                  <Button className="btn btn-continuar" onClick={handleModificarEmail}>
                    Modificar correo electrónico
                  </Button>
                </>
              : paso === 4 && socio ? 
                <Form onSubmit={handleQuestions}> 
                  <SelectorPreguntas arr={direcciones} name='chosenDirection' action={handleInputChange} label='Su domicilio actual es...'/>
                  <SelectorPreguntas arr={nombres} name='chosenNames' action={handleInputChange} label='¿Cual es su nombre completo?' />
                  <SelectorPreguntas arr={planes} name='chosenPlan' action={handleInputChange} label='Su plan contratado es...'/>
                  <Button 
                    className="btn btn-continuar" 
                    type="submit"
                    disabled={!state?.chosenDirection || !state?.chosenNames || !state?.chosenPlan}
                  >
                    Continuar
                  </Button>
                </Form> 
              : paso === 5 ? 
                <>
                  <Form onSubmit={handleEmail}> 
                    <p>
                      <Input
                        name="email"
                        placeholder="Ingresa un correo electrónico..."
                        type="text"
                        className="inputDni"
                        onChange={handleInputChange}
                      />
                    </p>
                    <p>{msg}</p>
                    <Button className="btn btn-continuar" type="submit" disabled={loading}>
                      Continuar
                    </Button>
                  </Form>
                </>
              : paso === 6 ? 
                <>
                  <p className='my-5 pt-2'>Ha ocurrido un error, intente nuevamente más tarde</p>
                  <Button className="btn btn-continuar" onClick={handleRedirect}>
                    VOLVER
                  </Button>
                </>
              : null
  }

  return (
    <>
      <img src={logoCiba} className="logoCiba mt-5" alt=""  />
      <Card className="p-4 text-center mt-4">
        <p className="mt-2 title">RECUPERAR CONTRASEÑA</p>
        {handlePasos()}
      </Card>
    </>
  );
}

const SelectorPreguntas = ({action, arr, name, label}) => {
  return(
    <p>
      <Label>{label}</Label>
      <Input type='select' onChange={action} name={name}>
        <option>Seleccionar...</option>
        {arr.map( o => {
          return  <option key={o} value={o}>{o}</option> 
        })}
        
      </Input>
    </p>
  )
}

export default Recupero;
